import { Link } from "react-router-dom";
import { Icon } from "./Icon";
import { PageTitle } from "./PageTitle";
import { Button, EmptyState } from "./ui";

type Props = {
  phaseNum: 2 | 3;
  phaseLabel: string;
  title: string;
  mode: "no_target" | "no_job";
  targetName?: string;
};

export function DeskTargetGate({
  phaseNum,
  phaseLabel,
  title,
  mode,
  targetName,
}: Props) {
  const noTarget = mode === "no_target";
  const company = targetName?.trim() || "this company";

  return (
    <main className="flex-1 flex flex-col overflow-hidden min-h-0">
      <PageTitle phaseNum={phaseNum} phaseLabel={phaseLabel} title={title} />
      <EmptyState
        className="flex-1"
        title={noTarget ? "Select a target first" : `No search run for ${company}`}
        description={
          noTarget
            ? `Set a target company on Search before opening ${phaseLabel}.`
            : `Run searches for ${company} on Search first. ${phaseLabel} needs a completed Phase 1 job for this target.`
        }
      >
        <Icon
          name={noTarget ? "corporate_fare" : "search"}
          className="text-5xl text-outline-variant mb-4"
        />
        <Link to="/search" className="mt-4">
          <Button variant="primary">{noTarget ? "Go to Search" : "Run searches"}</Button>
        </Link>
      </EmptyState>
    </main>
  );
}
